import t from "./highrise1472.mjs";
import a from "./highrise1473.mjs";
var i = a(function(e, r, o) {
  t(e, r, o);
});
export {
  i as default
};
